import { z } from 'zod';
import { time } from '../../../common/atomic/time';
import { date } from '../../../common/atomic/date';
import { pageableRequestSchema } from '../../pageable/request';

export const exceptionalEventSchema = z.object({
  id: z.number(),
  name: z.string().min(1, { message: 'Název musí být aspoň 1 znák dlouhý' }),
  note: z.string().min(1, { message: 'Poznámka musí být aspoň 1 znák dlouhá' }),
  date,
  startTime: time,
  endTime: time,
  empId: z.number(),
});

export const exceptionalEventsSchema = z
  .object({
    content: z.array(exceptionalEventSchema),
  })
  .merge(pageableRequestSchema);

export type ExceptionalEvent = z.infer<typeof exceptionalEventSchema>;
export type ExceptionalEvents = z.infer<typeof exceptionalEventsSchema>;
